// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import {useSelector} from "react-redux";
import {useLocation, useParams} from "react-router";

import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";

import {IRPStore} from "../../../app/rp_reducer";
import {DEFAULT_DISTANCE_ON_BROWSER} from "../constants/offer_list";
import {OfferListSubType} from "../types/OfferListSubType";

export function usePageLinkBuilder() {
    const location = useLocation();
    const params = useParams<{offerListSubType?: OfferListSubType}>();

    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);

    return (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        if (!latestQuery.distance && !params.offerListSubType) {
            /*
             * If there is no value for distance in latestQuery than we need to set default distance on browser.
             * This is because on the client side we are extending offers list with those from distance of 5 km.
             * In order to present correct result when page change we need to have distance in query.
             *
             * Do not use this logic for subtype listings - there is no distance extending.
             */
            query.distance = DEFAULT_DISTANCE_ON_BROWSER.toString();
        }

        return appendQueryString(location.pathname, query) + location.hash;
    };
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import {useSelector} from "react-redux";
import {useLocation, useParams} from "react-router";

import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";

import {IRPStore} from "../../../app/rp_reducer";
import {DEFAULT_DISTANCE_ON_BROWSER} from "../constants/offer_list";
import {OfferListSubType} from "../types/OfferListSubType";

export function usePageLinkBuilder() {
    const location = useLocation();
    const params = useParams<{offerListSubType?: OfferListSubType}>();

    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);

    return (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        if (!latestQuery.distance && !params.offerListSubType) {
            /*
             * If there is no value for distance in latestQuery than we need to set default distance on browser.
             * This is because on the client side we are extending offers list with those from distance of 5 km.
             * In order to present correct result when page change we need to have distance in query.
             *
             * Do not use this logic for subtype listings - there is no distance extending.
             */
            query.distance = DEFAULT_DISTANCE_ON_BROWSER.toString();
        }

        return appendQueryString(location.pathname, query) + location.hash;
    };
}
